import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { combineLatest, Subscription, of, timer, Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { GraphqlService } from 'src/app/services/graphql.service';
import { Provider_License_Transaction } from 'src/generated/graphql';

@Component({
  selector: 'app-license-transactions',
  templateUrl: './license-transactions.component.html',
  styleUrls: ['./license-transactions.component.css']
})
export class LicenseTransactionsComponent implements OnInit {
  #subscription: Subscription;
  #stopPolling = new Subject<void>();
  status: Provider_License_Transaction = null;
  slug: string = '';
  pollCount: number = 0;
  elapsedSeconds: number = 0;
  paymentSuccess: boolean = false;
  pollingSuccessStopped: boolean = false;
  loader: boolean = false;

  constructor(private readonly router: Router,
    private readonly providerstateService: ProviderStateService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly graphqlService: GraphqlService
  ) { }




  successPolling({ pollingIntervalMs, maxPollingDurationMs, transactionId }: { pollingIntervalMs: number, maxPollingDurationMs: number, transactionId: string }) {
    const startTime = Date.now();

    this.#subscription = timer(0, pollingIntervalMs).pipe(
      // tap(() => {
      //   this.pollCount++;
      //   this.elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
      // }),
      switchMap(() => this.graphqlService.fetchProviderLicenseTransaction(transactionId)),
      // takeUntil(timer(maxPollingDurationMs).pipe(
      //   tap(() => {
      //     this.elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
      //   })
      // )),
      takeUntil(this.#stopPolling)
    ).subscribe(
      response => {
        this.status = response;
        if (this.shouldStopPolling(response)) {
          this.pollingSuccessStopped = true
          this.#stopPolling.next(); // Stop polling when condition is met
        }
      },
      error => {
        console.error('Error polling data', error);
      }
    );
  }

  ngOnDestroy(): void {
    if (this.#subscription) {
      this.#subscription.unsubscribe();
    }
    this.#stopPolling.next();
    this.#stopPolling.complete();
  }

  // Function to determine if polling should stop
  private shouldStopPolling(response: any): boolean {
    // Implement your condition logic here
    return response && response.status == 'SUCCESS';
  }

  ngOnInit(): void {
    const pollingIntervalMs = 5000; // Poll every 5 seconds
    const maxPollingDurationMs = 60000; // Stop polling after 1 minute
    this.slug = this.providerstateService.getProviderSlug();
    combineLatest([
      this.activatedRoute.paramMap,
      this.activatedRoute.queryParamMap
    ]).subscribe(([params, queryParams]) => {
      const resultType = params.get('resultType')
      const transactionId = queryParams.get('transactionId')
   
      if (resultType && transactionId) {
        switch (resultType) {
          case 'success': {
            this.paymentSuccess = true
            this.loader = true;
            this.successPolling({ pollingIntervalMs, maxPollingDurationMs, transactionId })
            this.loader = false;
            break;
          }
          case 'canceled': {
            this.paymentSuccess = false
            break
          }
          default: {
            console.error("Invalid result type");
          }
        }
      } else {
        console.error("Invalid result and transaction data");
      }
    });
  }

  RouterNavigation(path: string) {
    this.router.navigate([path]);
  }

  gotodashboard() {
    this.RouterNavigation("/" + this.slug + "/doctor/dashboard");
  }

  goToLicensePage() {
    this.RouterNavigation("/" + this.slug + "/doctor/license_plans")
  }

}
